import { createAction } from '@/utility/actions';

import {
  SR_USERS_GET_DETAILS,
  SR_USERS_CLEAN_DETAILS,
  SR_USERS_GET_PAYMENTS,
  SR_USERS_SEND_TRANSFER_REQUEST,
} from './_types.ts';

/**
 * Get SR User Details
 * @param {object} params
 */
export const getSRUserDetails = createAction(SR_USERS_GET_DETAILS);

/**
 * Clean SR User Payments
 */
export const cleanSRUserDetails = createAction(SR_USERS_CLEAN_DETAILS);

/**
 * Get SR User Payments
 * @param {number} user_id
 * @param {object} params
 */
export const getSRUserPayments = createAction(SR_USERS_GET_PAYMENTS);

/**
 * Send SR User Transfer request
 * @param {number} user_id
 * @param {object} params
 */
export const sendSRUserTransferRequest = createAction(SR_USERS_SEND_TRANSFER_REQUEST);

export default {
  getSRUserDetails,
  cleanSRUserDetails,
  getSRUserPayments,
  sendSRUserTransferRequest,
};
